<template>
  <div>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="tittle primary--text">{{ section }}</div>
      <v-spacer/>
      <div class="d-flex justify-end align-center mr-3">
        <!-- <v-btn
          v-if="purchaseOrdersPermissions['create-purchase-order-by-xml'] && countryRestaurant === 'MX'"
          class="d-none d-md-inline mr-3 mb-3 mb-md-0 white--text"
          rounded
          color="purple"
          small
          depressed
          @click="useCreateByXMLDialog = true">
          {{ $t('orders.buttons.xml') }}
        </v-btn> -->
        <v-tooltip bottom>
          <template
            v-slot:activator="{ on }">
            <v-btn
              class="mr-3"
              v-if="purchaseOrderPermissions['generate-purchase-order-report']"
              v-on="on"
              :href="exportRoute"
              target="_blank"
              dark
              fab
              x-small
              depressed
              color="secondary">
              <v-icon color="white">mdi-application-export</v-icon>
            </v-btn>
          </template>
          <span>Exportar ordenes de compra a CSV</span>
        </v-tooltip>
        <!-- <v-btn
          v-if="countryRestaurant === 'MX'"
          class="d-none d-md-inline mr-3 mb-3 mb-md-0 white--text"
          rounded
          color="blue"
          small
          depressed
          @click="openDownloadInvoicesAndCreateOrders">
          Buscar facturas y crear órdenes
        </v-btn> -->
        <v-text-field
          :value="searchOrder"
          append-icon="mdi-magnify"
          label="Busca ordenes por id"
          solo
          rounded
          hide-details
          flat
          dense
          @input="search"
        />
      </div>
    </div>

    <v-flex xs12>
      <v-skeleton-loader v-if="overlay" type="table" />
      <v-data-table
        v-else
        :loading="table.loading"
        :loading-text="table.title"
        :server-items-length="tableTotal"
        :headers="headers"
        :items="tableData"
        :options="tableOptions"
        :footer-props="{
          'items-per-page-options': [25, 50, 100]
        }"
        :items-per-page="25"
        sort-by="updatedAt"
        @update:options="updateTable"
        class="elevation-1 fixed-header">
        <template v-slot:top>
          <div class="px-3 filters">
            <v-row>
              <v-col cols="12" sm="6" md="2">
                <div class="d-flex align-center">
                  <span class="mr-3">
                    Filtros:
                  </span>
                  <v-menu
                    ref="datePicker"
                    v-model="datePicker"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="range"
                        label="Rango de fechas"
                        prepend-icon="mdi-calendar"
                        readonly
                        hide-details
                        dense
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dates"
                      :range="true"
                      first-day-of-week="1"
                      no-title
                      :max="untilToday"
                    >
                      <div>
                        <div class="px-2 pb-3">
                          <div class="grey--text pb-2">
                            Estatus de las ordenes en la fecha seleccionada:
                          </div>
                          <v-btn-toggle
                            v-model="statusChanges"
                            rounded
                            color="primary"
                            active-class="primary white--text"
                          >
                            <v-btn value="confirmed" class="ml-0" small color="white">
                              Confirmada
                            </v-btn>
                            <v-btn value="invoiced" class="ml-0" small color="white">
                              Facturada
                            </v-btn>
                            <v-btn value="received" class="ml-0" small color="white">
                              Recibida
                            </v-btn>
                            <v-btn value="paid" class="ml-0" small color="white">
                              Pagada
                            </v-btn>
                          </v-btn-toggle>
                        </div>
                        <div class="d-flex">
                          <v-btn text color="primary" @click="resetDate">Borrar</v-btn>
                          <v-spacer/>
                          <v-btn text color="grey" @click="datePicker = false">Cancel</v-btn>
                          <v-btn :disabled="dates.length < 2" color="primary" @click="filterByDates">OK</v-btn>
                        </div>
                      </div>
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3">
                <v-select
                  :value="statusSelected"
                  :items="statuses"
                  item-text="text"
                  item-value="value"
                  label="Status"
                  hide-details
                  dense
                  multiple
                  @change="filterByStatus"
                  @click:clear="filterByStatus"
                />
              </v-col>
              <v-col
                v-if="['manager', 'read-only'].includes($is())"
                cols="12"
                sm="12"
                md="2">
                <v-autocomplete
                  :value="providerSelected"
                  :items="searchProvider.items"
                  loading="Cargando proveedores"
                  :search-input.sync="searchProvider.search"
                  outlined
                  clearable
                  rounded
                  color="primary"
                  hide-details
                  hide-no-data
                  hide-selected
                  item-text="name"
                  item-value="_id"
                  label="Buscar proveedor"
                  placeholder="Nombre del proveedor"
                  @change="filterByProvider"
                  @click:clear="filterByProvider"
                />
              </v-col>
              <v-col
                v-if="['manager', 'read-only'].includes($is())"
                cols="12"
                sm="6"
                md="3">
                <div class="d-flex justify-start">
                  <div class="px-1">
                    <v-text-field
                      v-model.number="min"
                      class="mt-0 pt-0"
                      single-line
                      label="Min"
                      type="number"
                      clearable
                      @click:clear="filterByAmount"
                      style="width: 95px"
                    ></v-text-field>
                  </div>
                  <div class="px-1">-</div>
                  <div class="px-1">
                    <v-text-field
                      v-model.number="max"
                      class="mt-0 pt-0"
                      single-line
                      label="Max"
                      type="number"
                      clearable
                      @click:clear="filterByAmount"
                      style="width: 95px"
                    ></v-text-field>
                  </div>
                  <div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          x-small
                          fab
                          depressed
                          :disabled="min === null || max === null"
                          v-on="on"
                          @click="filterByAmount">
                          <v-icon>
                            mdi-chevron-right
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        Filtrar por monto
                      </span>
                    </v-tooltip>
                  </div>
                </div>
              </v-col>
              <v-col >
                <div>
                  <div class="caption">
                    Total de ordenes de compra:
                  </div>
                  <div class="title">
                    ${{ table.totalOrders | toFixNumber(2) | numberWithComma }}
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:item.uuid="{ item }">
          <a href="" @click.prevent="openDialog(item)" v-if="purchaseOrderPermissions['read-purchase-orders']">
            {{ item.uuid }}
          </a>
          <label for="" v-else>
            {{ item.uuid }}
          </label>
        </template>
        <template v-slot:item.folio="{ item }">
            {{ item.invoices[0] ? item.invoices[0].folio : '-' }}
        </template>
        <template v-slot:item.status="{ item }">
          <v-tooltip
            top
            max-width="300">
            <template v-slot:activator="{ on }">
              <v-btn x-small icon v-on="on">
                <v-icon color="dark-grey">mdi-information</v-icon>
              </v-btn>
            </template>
            <span>
              {{ statusDescriptions(item.status) }}
            </span>
          </v-tooltip>
          <span :class="`${statusColors(item.status)}--text`">
            {{ statusNames(item.status) }}
          </span>
        </template>
        <template v-slot:item.total="{ item }">
          <span>
            {{ item.total | toFixNumber(2) | numberWithComma | prefix('$') }}
          </span>
        </template>
        <template v-slot:item.createdAt="{ item }">
          {{ !activeStatus ? convertToDateString(item.createdAt) :  convertToDateString(getDateStatus(item)) }}
        </template>
      </v-data-table>
    </v-flex>

    <detail-dialog
      :dialog="dialog"
      :show="true"
      :order.sync="order"
      v-on:update:order="order = $event"
      @close="closeDialog"
      @update="load"
    />

    <v-dialog
      @keydown.esc="useCreateByXMLDialog=false"
      v-model="useCreateByXMLDialog"
      max-width="450">
      <v-card>
        <v-card-title>
          Subir XML y crear orden de compra
        </v-card-title>
        <v-card-text>
          <v-file-input
            v-if="areaId"
            v-model="xmlFile"
            dense
            hide-details
            accept=".xml"/>
          <div v-else class="title">
            Selecciona un área para crear la orden de compra
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="primary"
            class="mr-4"
            outlined
            rounded
            small
            @click="closeCreateByXMLDialog">
            Cancelar
          </v-btn>
          <v-btn
            :disabled="disabled"
            color="primary"
            rounded
            small
            depressed
            @click="uploadXML">
            Subir XML
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DownloadInvoicesAndCreateOrders
      @updated="load"
      ref="downloadInvoicesAndCreateOrders"
    />

    <v-overlay :value="overlayCreateByXML" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </div>
</template>

<script>
import moment from 'moment'
import DetailDialog from '@/screens/purchaseOrders/Detail'
import DownloadInvoicesAndCreateOrders from '@/components/sidePanels/DownloadInvoicesAndCreateOrders'
import { debounce, isEqual } from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: 'Orders',
  components: { DetailDialog, DownloadInvoicesAndCreateOrders },
  data () {
    return {
      overlayCreateByXML: false,
      useCreateByXMLDialog: false,
      datePicker: false,
      xmlFile: null,
      dates: [],
      section: 'Ordenes de compra',
      dialog: false,
      status: [],
      order: {},
      table: {
        title: 'Loading orders',
        firstLoad: false,
        loading: true,
        data: [],
        total: 0,
        headers: [],
        options: {
          page: 1,
          itemsPerPage: 25,
          sortBy: ['updatedAt'],
          sortDesc: [false],
          groupBy: [],
          groupDesc: [],
          mustSort: false,
          multiSort: false
        },
        totalOrders: 0
      },
      form: {
        valid: false,
        data: {
          id: undefined,
          name: null,
          author: {}
        },
        rules: {
          name: [v => !!v || this.$t('validations.name')]
        }
      },
      providers: [],
      provider: '',
      uuid: '',
      statusChanges: '',
      searchProvider: {
        search: '',
        selected: null,
        items: [],
        isLoading: false
      },
      min: null,
      max: null,
      activeStatus: false
    }
  },
  watch: {
    'searchProvider.search': debounce(async function (val) {
      this.searchProvider.isLoading = true
      const params = {
        name: `/${val}/i`,
        fetchAll: true
      }
      try {
        const res = await this.$api.get(`/v1/providers`, params)
        this.searchProvider.items = res.data
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.searchProvider.isLoading = false
    }, 600)
  },
  computed: {
    ...mapGetters({
      countryRestaurant: 'currentRestaurant/country'
    }),
    exportRoute () {
      const dates = this.dates.length === 2
        ? [this.$moment(this.dates[0]).startOf('day').toISOString(), this.$moment(this.dates[1]).endOf('day').toISOString()]
        : [null, null]
      let url = `${process.env.VUE_APP_API_URL}/v1/orders/export/csv`
      url += `?access_token=${this.$store.state.login.token}`
      url += `&restaurant=${this.$store.state.currentRestaurant.data._id}`
      url += `&area=${this.areaId}`
      if (this.statusSelected) url += `&status=${this.statusSelected.join()}`
      if (this.dates.length) url += `&createdAt>=${dates[0]}&createdAt<=${dates[1]}`
      if (this.statusChanges) url += `&statusChanges=${this.statusChanges}`
      if (this.providerSelected) url += `&provider=${this.providerSelected}`
      return url
    },
    disabled () {
      return !this.xmlFile
    },
    purchaseOrderPermissions () {
      return this.$store.state.login.permissions['purchase-orders'].components['purchase-orders-list'].actions
    },
    purchaseOrdersPermissions () {
      return this.$store.state.login.permissions['purchase-orders'].components['manual-purchase-orders-form'].actions
    },
    range () {
      // const dates = this.$store.state.entities.orders.dates
      const dates = this.dates
      return dates.length < 2 ? '' : `${dates[0]} / ${dates[1]}`
    },
    tableOptions () {
      return this.table.options
    },
    tableTotal () {
      return this.table.total
    },
    tableData () {
      return this.table.data.map((order, i) => {
        order.ago = moment(order.updatedAt).fromNow()

        return order
      })
    },
    overlay () {
      // return this.$store.state.entities.orders.isLoading
      return this.table.firstLoad
    },
    searchOrder () {
      // return this.$store.state.entities.orders.search
      return this.uuid
    },
    providerSelected () {
      return this.provider
      // return  this.$store.state.entities.orders.provider
    },
    statusSelected () {
      return this.status
      // return this.$store.state.entities.orders.status
    },
    statusChangesSelected () {
      return this.$store.state.entities.orders.statusChanges
    },
    areaId () {
      return this.$store.state.area.id
    },
    statuses () {
      if (this.$is() === 'provider') {
        return [
          { text: 'Por confirmar', value: 'sent' },
          { text: 'Confirmada', value: 'confirmed' },
          { text: 'Cancelada', value: 'canceled' },
          { text: 'Facturada', value: 'invoiced' },
          { text: 'Entregada', value: 'received' },
          { text: 'Pendiente de pago', value: 'pending_payment' },
          { text: 'Cobrada', value: 'paid' }
        ]
      }
      return [
        { text: 'Enviada', value: 'sent' },
        { text: 'Confirmada', value: 'confirmed' },
        { text: 'Cancelada', value: 'canceled' },
        { text: 'Facturada', value: 'invoiced' },
        { text: 'Recibida', value: 'received' },
        { text: 'Pendiente de pago', value: 'pending_payment' },
        { text: 'Pagada', value: 'paid' }
      ]
    },
    headers () {
      let dateText = 'Fecha de emisión'
      const headers = [
        { text: 'No. de Orden de compra', value: 'uuid' },
        { text: 'Fecha de emisión', value: 'createdAt' },
        { text: 'Nombre del emisor', value: 'author.email', sortable: false },
        { text: 'Folio', value: 'folio', sortable: false },
        { text: 'Monto', value: 'total', sortable: false },
        { text: 'Estatus', value: 'status', sortable: false },
        { text: 'Última modificación', value: 'ago', sortable: false }
      ]
      if (this.$is() === 'provider') {
        headers.splice(1, 0, { text: 'Restaurant', value: 'restaurant' })
        return headers
      }

      if (this.statusChanges === 'confirmed') {
        dateText = 'Fecha de confirmación'
      }
      if (this.statusChanges === 'invoiced') {
        dateText = 'Fecha de facturación'
      }
      if (this.statusChanges === 'received') {
        dateText = 'Fecha de recepción'
      }
      if (this.statusChanges === 'paid') {
        dateText = 'Fecha de pago'
      }

      headers.splice(1, 1, { text: dateText, value: 'createdAt' })
      headers.splice(1, 0, { text: 'Proveedor', value: 'provider.name' })
      return headers
    },
    untilToday () {
      return moment().format('YYYY-MM-DD')
    }
  },
  async mounted () {
    this.table.firstLoad = true
    await this.load()
    await this.$store.dispatch('getUnits')
    this.table.firstLoad = false
  },
  methods: {
    getDateStatus (item) {
      const data = item.statusChanges.find(x => x.name === this.statusChanges)
      return data.createdAt
    },
    openDownloadInvoicesAndCreateOrders () {
      this.$refs.downloadInvoicesAndCreateOrders.open()
    },
    uploadXML: async function () {
      this.overlayCreateByXML = true
      try {
        await this.$api.post('/v1/orders/create-by-xml', { xmlFile: this.xmlFile, area: this.areaId }, { delivery: 'formData' })
        this.$toasted.show('La orden de compra se creó correctamente', { duration: 3000 })
        this.closeCreateByXMLDialog()
        this.xmlFile = null
        await this.load()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlayCreateByXML = false
    },
    closeCreateByXMLDialog () {
      this.useCreateByXMLDialog = false
    },
    async filterByDates () {
      if (this.dates.length) {
        this.dates.sort((a, b) => {
          if (a < b) return -1
          if (a > b) return 1
          return 0
        })
        this.datePicker = false
        await this.load()
        if (this.statusChanges) this.activeStatus = true
      }
    },
    filterByStatus: debounce(async function (val) {
      this.status = val
      await this.load()
    }, 300),
    search: debounce(async function (val) {
      this.uuid = val
      await this.load()
    }, 500),
    filterByProvider: debounce(async function (val) {
      this.provider = val
      await this.load()
    }, 300),
    filterByAmount: debounce(async function (val) {
      this.amount = val
      await this.load()
    }, 300),
    calculateIepsProduct (product) {
      const ieps = product.taxes.find(tax => tax.satCode === '003')
      return ieps
        ? ieps.base
        : 0
    },
    calculateIvaProduct (product) {
      const iva = product.taxes.find(tax => tax.satCode === '002')
      return iva
        ? product.total * (iva.base / 100)
        : 0
    },
    async resetDate () {
      this.dates = []
      this.statusChanges = ''
      this.activeStatus = false
      await this.load()
      this.datePicker = false
    },
    statusNames (status) {
      if (this.$is() === 'provider') {
        return {
          sent: 'Nueva orden',
          confirmed: 'Confirmada',
          canceled: 'Cancelada',
          invoiced: 'Facturada',
          invalid: 'Factura no coincide',
          received: 'Entregada',
          pending_payment: 'Pendiente de pago',
          paid: 'Cobrada'
        }[status]
      }

      return {
        created: 'Sin enviar',
        sent: 'Enviada',
        confirmed: 'Confirmada',
        canceled: 'Cancelada',
        invoiced: 'Facturada',
        invalid: 'Factura no coincide',
        invalid_invoice: 'Factura no coincide',
        received: 'Recibida',
        pending_payment: 'Pendiente de pago',
        paid: 'Pagada'
      }[status]
    },
    statusColors (status) {
      return {
        created: 'grey',
        sent: 'grey',
        confirmed: 'info',
        canceled: 'red',
        invoiced: 'info',
        invalid: 'red',
        invalid_invoice: 'red',
        received: 'primary',
        pending_payment: 'primary',
        paid: 'primary'
      }[status]
    },
    statusDescriptions (status) {
      return {
        created: 'Orden de compra que no se ha enviado al proveedor',
        sent: 'Orden de compra enviada al proveedor, el proveedor debe confirmar el producto solicitado.',
        confirmed: 'El proveedor confirmó la orden y el producto solicitado.',
        canceled: 'Orden de compra cancelada.',
        invoiced: 'El proveedor o el restaurante ya subió la factura de esta orden de compra. La orden se encuentra en espera de recibir la mercancía.',
        invalid: 'El contenido de la factura adjunta a la orden de compra no coincide con la información en la orden de compra.',
        invalid_invoice: 'El contenido de la factura adjunta a la orden de compra no coincide con la información en la orden de compra.',
        received: 'El restaurante recibió y facturó correctamente la mercancía.',
        pending_payment: 'La orden de compra está a crédito.',
        paid: 'La orden de compra fue pagada correctamente.'
      }[status]
    },
    closeDialog: function () {
      this.dialog = false
    },
    openDialog (item) {
      this.order = item
      this.dialog = true
    },
    updateTable: async function (data) {
      if (!isEqual(this.table.options, data)) {
        this.table.options = data
        await this.load()
      }
    },
    async load () {
      this.table.loading = true
      const params = {
        limit: this.table.options.itemsPerPage,
        skip: this.table.options.itemsPerPage * (this.table.options.page - 1),
        sort: '-createdAt',
        restaurant: this.$store.state.currentRestaurant.data._id,
        area: this.$store.state.area.id
      }

      if (this.provider) {
        params.provider = this.provider
      }

      if (this.status.length) {
        params.status = this.status.join()
      }

      if (this.uuid) {
        params.uuid = `/${this.uuid}/gi`
      }

      if (this.dates.length) {
        const dates = this.dates.sort((a, b) => {
          if (a < b) return -1
          if (a > b) return 1
          return 0
        })
        params['createdAt>'] = moment(dates[0]).startOf('day').toISOString()
        params['createdAt<'] = moment(dates[1]).endOf('day').toISOString()
        if (this.statusChanges) {
          params['statusChanges'] = this.statusChanges
        }
      }

      if (this.min !== null && this.max !== null) {
        params['total>'] = this.min
        params['total<'] = this.max
      }

      try {
        const response = await this.$api.get('/v1/orders', params)
        this.table.data = response.data
        this.table.total = response.total
        this.table.totalOrders = response.totalOrders
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    convertToDateString (date) {
      const d = new Date(date)
      return d.toLocaleDateString('es-MX')
    }
    // async loadProviders () {
    //   try {
    //     const providers = await this.$api.get('/v1/providers')
    //     providers.data.unshift({
    //       name: 'Todos',
    //       _id: ''
    //     })
    //     this.providers = providers.data
    //   } catch (error) {
    //     this.$toasted.show(error.message, { duration: 3000 })
    //   }
    // }
  }
}
</script>
